import React, { useState } from 'react';
import LayoutSidebar from './components/LayoutSidebar';
import LayoutHeader from './components/LayoutHeader';
import DashboardPage from './pages/DashboardPage';
import WalksPage from './pages/WalksPage';
import BillingPage from './pages/BillingPage';
import AlbumPage from './pages/AlbumPage';
import TasksPage from './pages/TasksPage';
import ServicesPage from './pages/ServicesPage';
import RoutesPage from './pages/RoutesPage';
import CertificatesPage from './pages/CertificatesPage';
import PetsDashboardPage from './pages/PetsDashboardPage';
import TeamsPage from './pages/TeamsPage';

const App = () => {
  const [currentPage, setCurrentPage] = useState('dashboard');

  return (
    <div className="min-h-screen bg-gray-50">
      <LayoutSidebar setCurrentPage={setCurrentPage} />
      <LayoutHeader />
      
      <main className="md:ml-48 p-4">
        {currentPage === 'dashboard' && <DashboardPage />}
        {currentPage === 'walks' && <WalksPage />}
        {currentPage === 'billing' && <BillingPage />}
        {currentPage === 'certificates' && <CertificatesPage />}
        {currentPage === 'album' && <AlbumPage />}
        {currentPage === 'tasks' && <TasksPage />}
        {currentPage === 'services' && <ServicesPage />}
        {currentPage === 'routes' && <RoutesPage />}
        {currentPage === 'teams' && <TeamsPage />}
        {currentPage === 'pets' && <PetsDashboardPage />}
      </main>
    </div>
  );
};

export default App;

// DONE